// src/contexts/LanguageContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import en from '../translations/en.json';
import es from '../translations/es.json';

const LanguageContext = createContext(undefined);

// WU-141 S-10 (i) hid the language switch until English exists; WU-164 D6 (QA-F03, Q-2 (b)) makes this the one flag. While it is false
// every page is Spanish: the provider starts 'es' and ignores a saved 'en' (writing 'es' over it at the first load), and the switches -
// components/shared/LanguageToggle.js and the landing menu's, which reads it through contexts/languages/LanguageContext.ts - render
// nothing. Setting it true brings both back (docs/manifest/WU-164.md SESSION 1 RECORD § UNIT 1 THE DESIGN D6).
export const ENGLISH_AVAILABLE = false;

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    if (!ENGLISH_AVAILABLE) return 'es';
    return localStorage.getItem('language') || 'es';
  });

  useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);

  const translations = language === 'en' ? en : es;

  const t = (key) => {
    const keys = key.split('.');
    let value = translations;
    for (const k of keys) {
      value = value?.[k];
      if (value === undefined) return key;
    }
    return value || key;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useTranslation = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useTranslation must be used within LanguageProvider');
  }
  return context;
};
